import { API_END_POINTS } from "../../constant/config";
import Filter from "../../utils/Filter";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { GET_SHOPIFY, CREATE_SHOPIFY, GET_SINGLE_SHOPIFY, UPDATE_SHOPIFY, DELETE_SHOPIFY } from "../type"

// Fetch shopify pricing
export const fetchShopifyDataPricing = (query) => async (dispatch) => {
    try {

        let sort;
        sort = query.sortOrder === "asc" ? query.sortField : `-${query.sortField}`

        const apiEndpoint = `${API_END_POINTS.FETCH_SHOPIFY}`;
        let url = `${apiEndpoint}/`;
        (query.pageNumber && query.pageNumber != null) && (url += `?page=${query.pageNumber}`);
        (query.pageSize && query.pageSize != null) && (url += `&limit=${query.pageSize}`);
        (query.search && query.search != null) && (url += `&search=${(query.search).trim()}`);
        (sort) && (url += `&sort=${sort}`);

        const response = await JsonInterceptor.get(url)
        // const filter = new Filter();
        // const data = filter.baseFilter(response.data.data.docs, query);
        dispatch({
            type: GET_SHOPIFY,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Create shopify-Priccing
export const createShopifyPricing = (data) => async (dispatch) => {

    const updated_price_data = {
        ...data,
    }

    updated_price_data.plan_price = parseFloat(data.plan_price).toFixed(2);

    try {
        const apiEndpoint = API_END_POINTS.CREATE_SHOPIFY;
        const response = await JsonInterceptor.post(`${apiEndpoint}`, updated_price_data)
        return dispatch({
            type: CREATE_SHOPIFY,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: CREATE_SHOPIFY,
                payload: error.response.data,
            });
        }
    }
};

// Get Single Shopify pricing
export const fetchSingleShopify = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SINGLE_SHOPIFY;
        const response = await JsonInterceptor.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_SHOPIFY,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Update SHopify pricing
export const updateShopifyPricing = (data, id) => async (dispatch) => {

    const updated_price_data = {
        ...data,
    }

    updated_price_data.plan_price = parseFloat(data.plan_price).toFixed(2);
    try {
        const apiEndpoint = API_END_POINTS.UPDATE_SHOPIFY;
        const response = await JsonInterceptor.put(`${apiEndpoint}/${id}`, updated_price_data)
        return dispatch({
            type: UPDATE_SHOPIFY,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: UPDATE_SHOPIFY,
                payload: error.response.data,
            });
        }
    }
};

// Delete Shopify Pricing
export const deleteShopifyPricing = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.DELETE_SHOPIFY;
        await JsonInterceptor.delete(`${apiEndpoint}/${id}`)
        dispatch({
            type: DELETE_SHOPIFY,
        });
    } catch (error) {
        console.log("error", error);
    }
};